export const feedbackMockData = [
    {
      id: 1,
      img: "https://images.unsplash.com/photo-1529421308261-680c3a1b70c7?auto=format&fit=crop&w=800&q=60",
      title: "รพ.มหาราชนครเชียงใหม่ ปรับปรุงระบบลิฟต์ใหม่",
      text: "รพ.มหาราชนครเชียงใหม่ ปรับปรุงระบบลิฟต์ใหม่",
      description:
        "พื้นที่สำหรับรวบรวม Feedback จากผู้ใช้งานจริง ทั้งด้านความสะดวกในการค้นหาปลายทาง ความเข้าใจของเส้นทางนำทาง ความแม่นยำของตำแหน่ง และปัญหาที่พบ",
      cat: "ทางเข้า",
      catTone: "orange",
      date: "24 มค 2566",
      time: "10:45 AM",
      status: "pending",
      reporterName: "Admin",
      reporterEmail: "Admin01@gmail.com",
    },
    {
      id: 2,
      img: "https://images.unsplash.com/photo-1479839672679-a46483c0e7c8?auto=format&fit=crop&w=800&q=60",
      title: "เหมาะกับอาคารใหญ่ ๆ อย่างโรงพยาบาล",
      text: "เหมาะกับอาคารใหญ่ ๆ อย่างโรงพยาบาลสร้างทางเดินใหม่",
      description: "ระบบใช้งานได้ดี แต่ยังอยากให้มีการระบุโซนของห้องน้ำและทางเชื่อมให้ชัดขึ้น",
      cat: "ห้องน้ำ",
      catTone: "amber",
      date: "24 มค 2566",
      time: "11:10 AM",
      status: "pending",
      reporterName: "Admin",
      reporterEmail: "Admin01@gmail.com",
    },
    {
      id: 3,
      img: "https://images.unsplash.com/photo-1529429611273-0b1b2f6d4c64?auto=format&fit=crop&w=800&q=60",
      title: "โดยรวมใช้งานดี ไม่ต้องเปิด GPS ก็ยังนำทางได้",
      text: "โดยรวมใช้งานดี ไม่ต้องเปิด GPS ก็ยังนำทางได้",
      description: "โดยรวมใช้งานง่าย เข้าใจเส้นทางได้เร็ว และเหมาะกับผู้ใช้งานทั่วไป",
      cat: "ตำแหน่งไม่ตรง",
      catTone: "blue",
      date: "24 มค 2566",
      time: "01:20 PM",
      status: "pending",
      reporterName: "Admin",
      reporterEmail: "Admin01@gmail.com",
    },
    {
      id: 4,
      img: "https://images.unsplash.com/photo-1526779259212-939e64788e3c?auto=format&fit=crop&w=800&q=60",
      title: "ชอบที่ระบบบอกขั้นตอนการเดินเป็นช่วง ๆ",
      text: "ชอบที่ระบบบอกขั้นตอนการเดินเป็นช่วง ๆ เดินเสร็จ",
      description: "อยากให้เพิ่มการบอกระยะเวลาโดยประมาณในแต่ละช่วงของการเดิน",
      cat: "อื่นๆ",
      catTone: "purple",
      date: "24 มค 2566",
      time: "02:45 PM",
      status: "pending",
      reporterName: "Admin",
      reporterEmail: "Admin01@gmail.com",
    },
    {
      id: 5,
      img: "https://images.unsplash.com/photo-1529421308261-680c3a1b70c7?auto=format&fit=crop&w=800&q=60",
      title: "แผนที่ดูเข้าใจง่าย คล้าย Google Maps",
      text: "แผนที่ดูเข้าใจง่าย คล้าย Google Maps ทำให้ใช้ง่าย",
      description: "ภาพรวมดีมาก ใช้งานแล้วเข้าใจง่าย และรู้สึกคุ้นเคย",
      cat: "อื่นๆ",
      catTone: "purple",
      date: "24 มค 2566",
      time: "03:10 PM",
      status: "done",
      reporterName: "Admin",
      reporterEmail: "Admin01@gmail.com",
    },
    {
      id: 6,
      img: "https://images.unsplash.com/photo-1479839672679-a46483c0e7c8?auto=format&fit=crop&w=800&q=60",
      title: "ชอบที่ระบบบอกขั้นตอนการเดินเป็นช่วง ๆ เดินเสร็จ",
      text: "ชอบที่ระบบบอกขั้นตอนการเดินเป็นช่วง ๆ เดินเสร็จ",
      description: "อยากให้รองรับหลายภาษาเพิ่มในอนาคต",
      cat: "อื่นๆ",
      catTone: "purple",
      date: "24 มค 2566",
      time: "04:00 PM",
      status: "done",
      reporterName: "Admin",
      reporterEmail: "Admin01@gmail.com",
    },
  ];
  